import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import DeliveryAreaForm from '@/components/v2/DeliveryAreaForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import DeliveryAreaAdd from '@/plugins/graphql/mutations/v2/delivery-area-create.gql';
import DeliveryAreaCities from '@/plugins/graphql/queries/v2/delivery-area-cities.gql';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import DeliveryAreasMixin from '@/helpers/vue_mixins/v2/ecommerce/DeliveryAreasMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let DeliveryAreaCreate = class DeliveryAreaCreate extends mixins(AlertMixin, RouterParamsAppMixin, DeliveryAreasMixin, CleverTapEventsMixin) {
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        this.create(form)
            .then(() => {
            const msg = successfulCreate('Delivery Area');
            this.successNotification(msg);
            this.deliveryAreaAction('SUBMIT CREATE');
            this.goToDeliveryAreasPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const appUuid = this.appUUID;
        const { regionName, cityName, deliveryFee } = form;
        await this.$apollo.mutate({
            mutation: DeliveryAreaAdd,
            variables: {
                input: {
                    regionName,
                    cityName,
                    deliveryFee,
                    appUuid,
                },
            },
            // update(cache: any, { data }: any) {
            //   const queryOptions = {
            //     query: DeliveryAreaCities,
            //     variables: {
            //       appUuid,
            //       regionCode: null,
            //     },
            //   };
            //   const { fetchAreaByCities } = cache.readQuery({
            //     ...queryOptions,
            //   });
            //   if (!fetchAreaByCities) {
            //     return;
            //   }
            //   const cachedAreaCities = {
            //     ...fetchAreaByCities,
            //   };
            //   cachedAreaCities.edges.unshift({
            //     node: data.deliveryAreaAdd.areaCity,
            //   });
            //   cache.writeQuery({
            //     ...queryOptions,
            //     data: {
            //       fetchAreaByCities: cachedAreaCities,
            //     },
            //   });
            // },
            refetchQueries: [
                {
                    query: DeliveryAreaCities,
                    variables: {
                        appUuid,
                        regionCode: null,
                    },
                },
            ],
        });
    }
};
DeliveryAreaCreate = __decorate([
    Component({
        components: {
            PageTitle,
            DeliveryAreaForm,
        },
    })
], DeliveryAreaCreate);
export default DeliveryAreaCreate;
